import styled from 'styled-components'
import { EuFontAwesomeIcon } from '@prisma'
import { gap } from '@styles'
import { EuLoader } from '@prisma'

export const Root = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  ${gap(30, 'px', 'v')}
`

export const StyledLoader = styled(EuLoader)`
  height: ${(props) => props.size}px;
`

export const SuccessIcon = styled(EuFontAwesomeIcon)<{ dimension: number; show: boolean }>`
  font-size: ${(props) => props.dimension}px;
`

export const MessagesContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  ${gap(10, 'px', 'v')}
`

export const Message = styled.div`
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: flex-end;
  ${gap(1, 'px', 'h')}
`

export const SubMessage = styled.div<{ hide: boolean }>`
  visibility: ${(props) => (props.hide ? 'hidden' : 'visible')}
  font-size: 14px;
`
